// coupon-common/src/modules/impact/saga.js
import { call, put, takeLatest } from 'redux-saga/effects';
import { OK } from 'http-status-codes';
import { actions, types } from './duck';
import * as api from './api';

const getErrorMessage = (response) =>
  (response && response.data && response.data.detail) ||
  (response && response.statusText) ||
  'Something went wrong';

function* getImpactCampaignsSaga() {
  try {
    yield put(actions.getImpactCampaignsRequest());
    const response = yield call(api.getImpactCampaigns);
    if (response.status === OK) {
      yield put(actions.getImpactCampaignsSuccess(response.data));
    } else {
      yield put(actions.getImpactCampaignsFailure(getErrorMessage(response)));
    }
  } catch (error) {
    yield put(actions.getImpactCampaignsFailure(error.message));
  }
}

function* getImpactDealsSaga({ params }) {
  try {
    yield put(actions.getImpactDealsRequest());
    const response = yield call(api.getImpactDeals, params);
    if (response.status === OK) {
      yield put(actions.getImpactDealsSuccess(response.data));
    } else {
      yield put(actions.getImpactDealsFailure(getErrorMessage(response)));
    }
  } catch (error) {
    yield put(actions.getImpactDealsFailure(error.message));
  }
}

function* getImpactCatalogsSaga({ params }) {
  try {
    yield put(actions.getImpactCatalogsRequest());
    const response = yield call(api.getImpactCatalogs, params);
    if (response.status === OK) {
      yield put(actions.getImpactCatalogsSuccess(response.data));
    } else {
      yield put(actions.getImpactCatalogsFailure(getErrorMessage(response)));
    }
  } catch (error) {
    yield put(actions.getImpactCatalogsFailure(error.message));
  }
}

function* getImpactCatalogItemsSaga({ params }) {
  try {
    yield put(actions.getImpactCatalogItemsRequest());
    const response = yield call(api.getImpactCatalogItems, params);
    if (response.status === OK) {
      yield put(actions.getImpactCatalogItemsSuccess(response.data));
    } else {
      yield put(actions.getImpactCatalogItemsFailure(getErrorMessage(response)));
    }
  } catch (error) {
    yield put(actions.getImpactCatalogItemsFailure(error.message));
  }
}

export default function* watcherSaga() {
  yield takeLatest(types.GET_IMPACT_CAMPAIGNS,     getImpactCampaignsSaga);
  yield takeLatest(types.GET_IMPACT_DEALS,         getImpactDealsSaga);
  yield takeLatest(types.GET_IMPACT_CATALOGS,      getImpactCatalogsSaga);
  yield takeLatest(types.GET_IMPACT_CATALOG_ITEMS, getImpactCatalogItemsSaga);
}